'use client';
import React, { useState, useMemo } from 'react';
import { Search, Filter, Download, Plus, ChevronUp, ChevronDown, Eye, Edit2 } from 'lucide-react';

import DeceasedDetailModal from './DeceasedDetailModal';

export type DeceasedRecord = {
  id: string;
  fullName: string;
  idNumber: string;
  dateOfBirth: string;
  dateOfDeath: string;
  burialDate: string;
  causeOfDeath: string;
  graveId: string;
  cemetery: string;
  block: string;
  plot: string;
  nextOfKin: string;
  nokRelationship: string;
  nokContact: string;
  gender: string;
  nationality: string;
  recordedBy: string;
};

export const deceasedRecords: DeceasedRecord[] = [
  { id: 'dec-001', fullName: 'Thandi Nxumalo', idNumber: '5104152345678', dateOfBirth: '15 Apr 1951', dateOfDeath: '27 Jul 2026', burialDate: '02 Aug 2026', causeOfDeath: 'Natural causes', graveId: 'NYD-MTH-B2-R1-009', cemetery: 'Mthatha', block: 'B2', plot: 'B2-R1-009', nextOfKin: 'Musa Nxumalo', nokRelationship: 'Husband', nokContact: '073 456 7890', gender: 'Female', nationality: 'South African', recordedBy: 'T. Mthembu' },
  { id: 'dec-002', fullName: 'Bongani Ntanzi', idNumber: '5501126789012', dateOfBirth: '12 Jan 1955', dateOfDeath: '30 Jul 2026', burialDate: '04 Aug 2026', causeOfDeath: 'Cardiac arrest', graveId: 'NYD-LIB-A2-R1-007', cemetery: 'Libode', block: 'A2', plot: 'A2-R1-007', nextOfKin: 'Zanele Ntanzi', nokRelationship: 'Wife', nokContact: '071 234 5678', gender: 'Male', nationality: 'South African', recordedBy: 'S. Madikizela' },
  { id: 'dec-003', fullName: 'Lungelo Maphumulo', idNumber: '4809234512678', dateOfBirth: '23 Sep 1948', dateOfDeath: '28 Jul 2026', burialDate: '03 Aug 2026', causeOfDeath: 'Respiratory failure', graveId: 'NYD-NGQ-A1-R2-014', cemetery: 'Ngqeleni', block: 'A1', plot: 'A1-R2-014', nextOfKin: 'Thandi Maphumulo', nokRelationship: 'Daughter', nokContact: '079 876 5432', gender: 'Male', nationality: 'South African', recordedBy: 'N. Gqomo' },
  { id: 'dec-004', fullName: 'Nosipho Cele', idNumber: '5803074321098', dateOfBirth: '07 Mar 1958', dateOfDeath: '24 Jul 2026', burialDate: '01 Aug 2026', causeOfDeath: 'Stroke', graveId: 'NYD-NGQ-B1-R3-011', cemetery: 'Ngqeleni', block: 'B1', plot: 'B1-R3-011', nextOfKin: 'Siyanda Cele', nokRelationship: 'Son', nokContact: '066 123 4567', gender: 'Female', nationality: 'South African', recordedBy: 'N. Gqomo' },
  { id: 'dec-005', fullName: 'Vusi Mkhize', idNumber: '4506085432109', dateOfBirth: '08 Jun 1945', dateOfDeath: '22 Jul 2026', burialDate: '30 Jul 2026', causeOfDeath: 'Natural causes', graveId: 'NYD-LIB-B2-R4-027', cemetery: 'Libode', block: 'B2', plot: 'B2-R4-027', nextOfKin: 'Lindiwe Mkhize', nokRelationship: 'Wife', nokContact: '072 345 6789', gender: 'Male', nationality: 'South African', recordedBy: 'S. Madikizela' },
  { id: 'dec-006', fullName: 'Mandla Sithole', idNumber: '6007145678901', dateOfBirth: '14 Jul 1960', dateOfDeath: '25 Jul 2026', burialDate: '—', causeOfDeath: 'Pending post-mortem', graveId: 'NYD-MTH-D1-R1-003', cemetery: 'Mthatha', block: 'D1', plot: 'D1-R1-003', nextOfKin: 'Buhle Sithole', nokRelationship: 'Daughter', nokContact: '082 567 8901', gender: 'Male', nationality: 'South African', recordedBy: 'T. Mthembu' },
  { id: 'dec-007', fullName: 'Ntombizodwa Gumede', idNumber: '6811236789012', dateOfBirth: '23 Nov 1968', dateOfDeath: '20 Jul 2026', burialDate: '—', causeOfDeath: 'Under investigation', graveId: '—', cemetery: 'Mthatha', block: '—', plot: '—', nextOfKin: 'Phiwayinkosi Gumede', nokRelationship: 'Son', nokContact: '081 234 5678', gender: 'Female', nationality: 'South African', recordedBy: 'T. Mthembu' },
  { id: 'dec-008', fullName: 'Sipho Khumalo', idNumber: '7209185432109', dateOfBirth: '18 Sep 1972', dateOfDeath: '02 Aug 2026', burialDate: '05 Aug 2026', causeOfDeath: 'Natural causes', graveId: 'NYD-LIB-A3-R2-018', cemetery: 'Libode', block: 'A3', plot: 'A3-R2-018', nextOfKin: 'Nokuthula Khumalo', nokRelationship: 'Wife', nokContact: '083 456 7891', gender: 'Male', nationality: 'South African', recordedBy: 'S. Madikizela' },
  { id: 'dec-009', fullName: 'Nokwanda Zulu', idNumber: '7803045678082', dateOfBirth: '04 Mar 1978', dateOfDeath: '01 Aug 2026', burialDate: '04 Aug 2026', causeOfDeath: 'Diabetes complications', graveId: 'NYD-MTH-B4-R3-022', cemetery: 'Mthatha', block: 'B4', plot: 'B4-R3-022', nextOfKin: 'Siphamandla Zulu', nokRelationship: 'Son', nokContact: '084 987 6543', gender: 'Female', nationality: 'South African', recordedBy: 'T. Mthembu' },
  { id: 'dec-010', fullName: 'Nomvula Dlamini', idNumber: '6412087654321', dateOfBirth: '08 Dec 1964', dateOfDeath: '02 Aug 2026', burialDate: '05 Aug 2026', causeOfDeath: 'Cancer', graveId: 'NYD-MTH-C1-R4-031', cemetery: 'Mthatha', block: 'C1', plot: 'C1-R4-031', nextOfKin: 'Lungelo Dlamini', nokRelationship: 'Brother', nokContact: '076 543 2109', gender: 'Female', nationality: 'South African', recordedBy: 'T. Mthembu' },
];

type SortKey = keyof DeceasedRecord;

const CEMETERY_FILTERS = ['All Cemeteries', 'Mthatha', 'Libode', 'Ngqeleni'];

export default function DeceasedRecordsContent() {
  const [search, setSearch] = useState('');
  const [cemeteryFilter, setCemeteryFilter] = useState('All Cemeteries');
  const [sortKey, setSortKey] = useState<SortKey>('burialDate');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const [selectedRecord, setSelectedRecord] = useState<DeceasedRecord | null>(null);
  const [page, setPage] = useState(1);
  const perPage = 8;

  const filtered = useMemo(() => {
    return deceasedRecords.filter((r) => {
      const matchCem = cemeteryFilter === 'All Cemeteries' || r.cemetery === cemeteryFilter;
      const matchSearch =
        !search ||
        r.fullName.toLowerCase().includes(search.toLowerCase()) ||
        r.idNumber.includes(search) ||
        r.graveId.toLowerCase().includes(search.toLowerCase());
      return matchCem && matchSearch;
    });
  }, [search, cemeteryFilter]);

  const sorted = [...filtered].sort((a, b) =>
    sortDir === 'asc'
      ? String(a[sortKey]).localeCompare(String(b[sortKey]))
      : String(b[sortKey]).localeCompare(String(a[sortKey]))
  );

  const totalPages = Math.ceil(sorted.length / perPage);
  const paged = sorted.slice((page - 1) * perPage, page * perPage);

  const toggleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir('asc'); }
  };

  const SortIcon = ({ col }: { col: SortKey }) => (
    <span className="inline-flex flex-col ml-1">
      <ChevronUp size={10} className={sortKey === col && sortDir === 'asc' ? 'text-primary' : 'text-muted-foreground/40'} />
      <ChevronDown size={10} className={sortKey === col && sortDir === 'desc' ? 'text-primary' : 'text-muted-foreground/40'} />
    </span>
  );

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-700 text-foreground">Deceased Records</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Permanent archive of all registered deceased persons
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button className="btn-ghost text-sm border border-border"><Download size={14} /> Export CSV</button>
          <button className="btn-primary text-sm"><Plus size={15} /> Add Record</button>
        </div>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[
          { id: 'dr-total', label: 'Total Records', value: deceasedRecords.length.toString() },
          { id: 'dr-mthatha', label: 'Mthatha', value: deceasedRecords.filter(r => r.cemetery === 'Mthatha').length.toString() },
          { id: 'dr-libode', label: 'Libode', value: deceasedRecords.filter(r => r.cemetery === 'Libode').length.toString() },
          { id: 'dr-ngqeleni', label: 'Ngqeleni', value: deceasedRecords.filter(r => r.cemetery === 'Ngqeleni').length.toString() },
        ].map((s) => (
          <div key={s.id} className="card-base px-4 py-3">
            <p className="text-xs text-muted-foreground">{s.label}</p>
            <p className="text-xl font-700 tabular-nums text-foreground">{s.value}</p>
          </div>
        ))}
      </div>

      {/* Search + Filter */}
      <div className="flex items-center gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[200px] max-w-sm">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search by name, ID number, or grave ID..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input-base pl-9 text-sm"
          />
        </div>
        <select
          value={cemeteryFilter}
          onChange={(e) => setCemeteryFilter(e.target.value)}
          className="input-base w-auto text-sm"
        >
          {CEMETERY_FILTERS.map((c) => <option key={`dec-cf-${c}`} value={c}>{c}</option>)}
        </select>
        <button className="btn-ghost text-sm border border-border"><Filter size={14} /> More Filters</button>
        <span className="text-sm text-muted-foreground ml-auto">{filtered.length} records</span>
      </div>

      {/* Table */}
      <div className="card-base overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border bg-muted/30">
                {([
                  ['fullName', 'Full Name'],
                  ['idNumber', 'ID Number'],
                  ['dateOfBirth', 'Date of Birth'],
                  ['dateOfDeath', 'Date of Death'],
                  ['burialDate', 'Burial Date'],
                  ['causeOfDeath', 'Cause of Death'],
                  ['graveId', 'Grave ID'],
                  ['cemetery', 'Cemetery'],
                  ['nextOfKin', 'Next of Kin'],
                ] as [SortKey, string][]).map(([key, label]) => (
                  <th
                    key={`th-dec-${key}`}
                    onClick={() => toggleSort(key)}
                    className="px-3 py-3 text-left text-[12px] font-600 text-muted-foreground uppercase tracking-wide cursor-pointer hover:text-foreground whitespace-nowrap"
                  >
                    {label} <SortIcon col={key} />
                  </th>
                ))}
                <th className="px-3 py-3 text-right text-[12px] font-600 text-muted-foreground uppercase tracking-wide">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {paged.map((rec) => (
                <tr key={rec.id} className="table-row-hover transition-colors cursor-pointer" onClick={() => setSelectedRecord(rec)}>
                  <td className="px-3 py-3 font-600 text-foreground whitespace-nowrap">{rec.fullName}</td>
                  <td className="px-3 py-3">
                    <span className="font-mono-data text-xs text-muted-foreground">{rec.idNumber}</span>
                  </td>
                  <td className="px-3 py-3 text-muted-foreground whitespace-nowrap">{rec.dateOfBirth}</td>
                  <td className="px-3 py-3 text-muted-foreground whitespace-nowrap">{rec.dateOfDeath}</td>
                  <td className="px-3 py-3 whitespace-nowrap">
                    {rec.burialDate === '—'
                      ? <span className="text-warning text-xs font-600">Pending</span>
                      : <span className="text-muted-foreground">{rec.burialDate}</span>}
                  </td>
                  <td className="px-3 py-3 text-muted-foreground max-w-[160px] truncate">{rec.causeOfDeath}</td>
                  <td className="px-3 py-3">
                    <span className="font-mono-data text-xs font-600 text-primary">
                      {rec.graveId === '—' ? <span className="text-muted-foreground">—</span> : rec.graveId}
                    </span>
                  </td>
                  <td className="px-3 py-3 text-muted-foreground">{rec.cemetery}</td>
                  <td className="px-3 py-3 text-muted-foreground whitespace-nowrap">
                    <div>
                      <p className="text-xs font-500 text-foreground">{rec.nextOfKin}</p>
                      <p className="text-[11px] text-muted-foreground">{rec.nokRelationship}</p>
                    </div>
                  </td>
                  <td className="px-3 py-3" onClick={(e) => e.stopPropagation()}>
                    <div className="flex items-center justify-end gap-1">
                      <button
                        onClick={() => setSelectedRecord(rec)}
                        className="w-7 h-7 flex items-center justify-center rounded hover:bg-muted transition-colors"
                        title="View Full Record"
                      >
                        <Eye size={14} className="text-muted-foreground" />
                      </button>
                      <button
                        className="w-7 h-7 flex items-center justify-center rounded hover:bg-muted transition-colors"
                        title="Edit Record"
                      >
                        <Edit2 size={14} className="text-muted-foreground" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-border">
          <span className="text-xs text-muted-foreground">
            Showing {Math.min((page - 1) * perPage + 1, sorted.length)}–{Math.min(page * perPage, sorted.length)} of {sorted.length} records
          </span>
          <div className="flex items-center gap-1">
            <button
              onClick={() => setPage(Math.max(1, page - 1))}
              disabled={page === 1}
              className="px-2 py-1 text-xs rounded border border-border hover:bg-muted disabled:opacity-40 transition-colors"
            >
              Previous
            </button>
            {Array.from({ length: totalPages }).map((_, i) => (
              <button
                key={`dec-page-${i + 1}`}
                onClick={() => setPage(i + 1)}
                className={`w-7 h-7 text-xs rounded border transition-colors ${
                  page === i + 1 ? 'bg-primary text-white border-primary' : 'border-border hover:bg-muted'
                }`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => setPage(Math.min(totalPages, page + 1))}
              disabled={page === totalPages}
              className="px-2 py-1 text-xs rounded border border-border hover:bg-muted disabled:opacity-40 transition-colors"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {selectedRecord && (
        <DeceasedDetailModal record={selectedRecord} onClose={() => setSelectedRecord(null)} />
      )}
    </div>
  );
}